// src/context/AuthContext.tsx
import { UserModel } from "models";
import { createContext, SetStateAction, useContext, useState } from "react";
import { CredentialService } from "services";

interface AuthContextType {
    auth: string | undefined
    saveAuth: (auth: string | undefined) => void
    currentUser: UserModel | undefined
    setCurrentUser: React.Dispatch<SetStateAction<UserModel | undefined>>
    logout: () => void
}

const initAuthContextType: AuthContextType = {
    auth: CredentialService.fetchAuthToken(),
    saveAuth: () => {},
    currentUser: undefined,
    setCurrentUser: () => {},
    logout: () => {},
  }

const AuthContext = createContext<AuthContextType | undefined>(initAuthContextType);

const useAuth = () => {
    return useContext(AuthContext)
}

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [auth, setAuth] = useState<string | undefined>(CredentialService.fetchAuthToken())
    const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
    const saveAuth = (auth: string | undefined) => {
      setAuth(auth)
      if (auth) {
        CredentialService.setAuthToken(auth)
      } else {
        CredentialService.deleteAuthToken()
      }
    }

    if (!currentUser) {
      const user = CredentialService.fetchUser()
      if (user) {
        setCurrentUser(user)
      }
    }
  
    const logout = () => {
      saveAuth(undefined)
      setCurrentUser(undefined)
    }
  
    return (
      <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
        {children}
      </AuthContext.Provider>
    )
}

export { AuthProvider, useAuth }
